import { render, staticRenderFns } from "./AddCommon.vue?vue&type=template&id=608c65a6&scoped=true"
import script from "./AddCommon.vue?vue&type=script&lang=js"
export * from "./AddCommon.vue?vue&type=script&lang=js"
import style0 from "./AddCommon.vue?vue&type=style&index=0&id=608c65a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608c65a6",
  null
  
)

export default component.exports